import { render, staticRenderFns } from "./dj_list.vue?vue&type=template&id=91841226&"
import script from "./dj_list.vue?vue&type=script&lang=js&"
export * from "./dj_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports